import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Home, ArrowLeft } from 'iconoir-react';
import Lottie from 'lottie-react';
import paraquedas from '../assets/paraquedas.json';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      textAlign: 'center'
    }}>
      {/* Animação Lottie */}
      <Lottie 
        animationData={paraquedas} 
        loop 
        style={{ width: 280, height: 280, marginBottom: '16px' }} 
      />

      {/* Título */}
      <h1 style={{
        fontSize: '1.75rem',
        fontWeight: 700,
        color: '#1a1a1a',
        marginBottom: '12px'
      }}>
        Você não caiu aqui de paraquedas, né?
      </h1>

      {/* Descrição */}
      <p style={{
        fontSize: '1rem',
        color: '#6b7280',
        maxWidth: '400px',
        marginBottom: '32px',
        lineHeight: 1.6
      }}>
        A página que você está procurando não existe ou foi movida para outro endereço.
      </p>

      {/* Botões de ação */}
      <div style={{
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        <Button
          variant="outline-secondary"
          onClick={() => navigate(-1)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px 24px',
            borderRadius: '12px',
            fontWeight: 600,
            fontSize: '0.95rem',
            border: '2px solid #e5e7eb',
            color: '#374151',
            background: '#fff'
          }}
        >
          <ArrowLeft size={18} />
          Voltar
        </Button>

        <Button
          variant="primary"
          onClick={() => navigate('/')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px 24px',
            borderRadius: '12px',
            fontWeight: 600,
            fontSize: '0.95rem',
            background: '#0039ff',
            border: 'none',
            boxShadow: '0 4px 12px rgba(0,57,255,0.25)'
          }}
        >
          <Home size={18} />
          Ir para o início
        </Button>
      </div>

      {/* Logo GRUB */}
      <div style={{
        marginTop: '48px',
        opacity: 0.7
      }}>
        <img 
          src="https://grubicons.s3.us-east-1.amazonaws.com/powered-by-grub.png" 
          alt="Powered by GRUB Digital" 
          style={{ height: '40px' }}
        />
      </div>
    </div>
  );
}

export default NotFound;
